import { ActionButton } from '../../components/vertical-dot/popper';
import { TableBodyCellColumn } from '../style/table.styled';

export const RolePublishHeader = ({
  actions,
  tableActions,
}: {
  actions: any;
  tableActions: any;
}): any[] => {
  //   const getActions = (rowData: Record<string, any>): any => {
  //     let newActions = [];
  //     if (selectedReportType === 'standardReport') {
  //       newActions = action.filter((item: any) => ['Customize'].includes(item.action));
  //     } else {
  //       newActions = action;
  //     }
  //     return newActions;
  //   };
  const newActions = [
    ...(actions || []),
    {
      accessor: 'actions',
      width: 20,
      sortable: false,
      isSubHeader: false,
      renderCell: true,
      hideOnSubRows: true,
      Cell: ({ row }: any) => {
        console.log('row', row);
        return (
          <td>
            <ActionButton
              actions={tableActions}
              id={row?.leafRows?.[0].original.publishId?.toString()}
              rowData={row?.leafRows?.[0].original}
              counter={parseInt(row?.leafRows?.[0].original.publishId?.toString())}
            />
          </td>
        );
      },
    },
  ];

  return newActions;
  return [
    {
      Header: 'Source Role',
      accessor: 'roleName',
      width: 150,
      sortable: false,
    },
    {
      Header: 'Destination Company',
      accessor: 'companyName',
      width: 150,
      sortable: false,
    },
    {
      accessor: 'actions',
      width: 20,
      sortable: false,
      Cell: ({ row }: any) => {
        return (
          <ActionButton
            actions={actions}
            id={row?.original?.publishId}
            rowData={row?.original}
            counter={parseInt(row?.id)}
          />
        );
      },
    },
  ];
};
